export default __webpack_public_path__ + "static/media/sass.06b70be0.png";